export default __webpack_public_path__ + "static/media/rose-reversed.2d127161.svg";